export default __webpack_public_path__ + "static/media/tuehinh.f07e2c55.png";